<template>
  <!-- <el-button type="info" icon="el-icon-message" circle @onchange="cambiar()"></el-button> -->
  <div>
    <div style="margin-bottom: 10px">
      <el-button type="warning" icon="el-icon-plus" @click="OpenDraweC"
        >Crear Contacto</el-button
      >
    </div>

    <rabbey-table-3
      ref="table"
      v-loading="loading"
      :columns="columns"
      :data="items"
      :actions="actions"
      @rtable-push-action="handlerAction"
      :page_Size="500"
      :page-sizes="[500, 1000]"
    />

    <contacts-view-rol
      :selectedContact="selectedContact"
      :visible.sync="drawerVisible"
      @close="handleDrawerClose"
      @toggle-active="handleToggleActive"
    ></contacts-view-rol>

    <contact-from
      ref="contact"
      :drawer.sync="drawerContact"
      @saved="getItems"
    />
  </div>
</template>

<script>
import SwitchButton from "@/components/functionals/SwitchButton.vue";
import ContactsViewRol from "./ContactsViewRol.vue";
import ContactFrom from "../contacts/ContactForm";
// import RenderCheckLabel from "@/components/functionals/RenderCheckLabel";

export default {
  name: "TableContacts",
  props: ["clientCode"],
  components: {
    ContactsViewRol,
    ContactFrom
  },
  data() {
    return {
      currentButtonColor: "green", // Color inicial del botón
      actions: [
        {
          icon: "el-icon-message",
          label: "Notificar",
          command: "change-status"
        },
        {
          icon: "el-icon-edit",
          label: "Editar Contacto",
          command: "edit-change"
        }
      ],
      loading: false,
      currency: "",
      import_remain: "",
      items: [],
      drawerVisible: false,
      selectedContact: null,
      drawerContact: false,
      columns: [
        {
          prop: "ContactCode", // filtrar que solo el boton salga en facturas
          label: "Acceso al Portal",
          align: "center",
          width: 150,
          sortable: false,
          formatter: SwitchButton
        },
        {
          prop: "CXC_Notifications", // filtrar que solo el boton salga en facturas
          label: "Notificaciones CXC",
          align: "center",
          width: 170,
          sortable: false,
          formatter: (row, col) => (
            <SwitchButton
              Call={this.notificaCXCSC}
              {...{ attrs: { row, col } }}
            />
          )
        },
        {
          prop: "SC_Notifications", // filtrar que solo el boton salga en facturas
          label: "Notificaciones SC",
          align: "center",
          width: 170,
          sortable: false,
          formatter: (row, col, rowValue) => (
            <SwitchButton
              Call={this.notificaCXCSC}
              {...{ attrs: { row, col, rowValue } }}
            />
          )
        },
        // {
        //   prop: "status",
        //   label: "Notificacion",
        //   formatter: RenderCheckLabel
        // },

        {
          prop: "ContactCode",
          label: "Codigo"
        },
        {
          prop: "FullName",
          label: "Nombre"
        },
        {
          prop: "Email",
          label: "Email"
        },
        {
          prop: "PhoneNumber",
          label: "Telefono"
        },
        {
          prop: "MobilePhoneNumber",
          label: "Celular"
        },
        {
          prop: "User",
          label: "Role",
          formatter: (row) => {
            const role = row.User?.Roles || "NO ROLES";
            const colorMap = {
              Admin: "#67C23A",
              Basico: "#409EFF",
              Financiero: "#E6A23C",
              Tecnico: "#909399",
              "NO ROLES": "#F56C6C"
            };
            const color = colorMap[role] || "#909399";
            const roles = role.toUpperCase();
            return (
              <el-link
                type="text"
                style={{
                  color,
                  fontWeight: "bold",
                  fontSize: "14px",
                  cursor: "pointer"
                }}
                onClick={() => this.openRoleDialog(row)}
              >
                {roles}
              </el-link>
            );
          }
        },
        {
          prop: "LastDateModified",
          label: "Ultima actualizacion"
        }
      ]
    };
  },
  created() {
    this.getItems();
  },
  methods: {
    OpenDraweC() {
      this.drawerVisible = false;
      if (this.$refs.contact?.showForCreate) {
        this.$refs.contact.showForCreate(this.clientCode);
      }
    },
    async handleToggleActive() {
      await this.getItems();
    },
    openRoleDialog(row) {
      this.selectedContact = row;
      this.drawerVisible = true;
    },
    handleDrawerClose() {
      this.selectedContact = null;
      this.drawerVisible = false;
    },
    handlerAction(action) {
      const { command } = action;
      switch (command) {
        case "change-status":
          this.notifica(action.row);
          break;

        case "edit-change":
          this.drawerVisible = false;
          if (this.$refs.contact?.showForEdit) {
            this.$refs.contact.showForEdit(action.row);
          }
          break;

        default:
          break;
      }
    },
    notifica(val) {
      this.loading = true;
      let usuario = {
        Nombre: val.FullName,
        Correo: val.Email,
        status: "ACT",
        codigo: val.CustomerCode,
        contccode: val.ContactCode
      };

      switch (val.status) {
        case null:
          this.createusertonotificar(usuario);

          break;
        case true:
          this.updateusertonotificar(val.iduser, "INA");

          break;
        case false:
          this.updateusertonotificar(val.iduser, "ACT");

          break;
      }
    },
    createusertonotificar(val) {
      this.$http
        .post("/api/tennos/PostNotification", val)
        .catch((error) => {
          console.error(error);
        })
        .then(() => {
          this.$message.success("Contacto agregado para notificar");
        })
        .finally(() => {
          this.loading = false;
          this.getItems();
        });
    },
    notificaCXCSC() {
      this.getItems();
    },
    updateusertonotificar(id, status) {
      this.$http
        .put("/api/tennos/UpdateStatusNoti/" + id + "/" + status + "")
        .catch((error) => {
          console.error(error);
        })
        .then(() => {
          if (status === "ACT") {
            this.$message.success("Contacto Activado ");
          } else {
            this.$message.success("Contacto Inactivado");
          }
        })
        .finally(() => {
          this.loading = false;
          this.getItems();
        });
    },
    getItems() {
      this.loading = true;
      this.items = [];
      this.$http
        .get("/api/contacts/GetContactByCustomerCode", {
          params: {
            customerCode: this.clientCode,
            companyCode: this.currentCompany
          }
        })
        .then(({ data }) => {
          this.items = data.map((item) => {
            if (item.status === "ACT") {
              return {
                ...item,
                status: true
              };
            } else if (item.status === "INA") {
              return {
                ...item,
                status: false
              };
            } else {
              return {
                ...item,
                status: null
              };
            }
          });
        })
        .catch((error) => {
          this.$message.error("Error al consultar los contratos");
          console.error(error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    clientCode(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.getItems();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tags span:not(:first-child) {
  margin-left: 5px;
}
.el-table .warning-row {
  background: red;
}

.el-table .success-row {
  background: #f0f9eb;
}

.role-details {
  padding: 20px 10px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #ebeef5;

  label {
    font-weight: bold;
    color: #333;
    min-width: 120px;
  }

  span {
    color: #606266;
  }
}
</style>
